/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { RoleGrant, RoleGrant$inboundSchema } from "./rolegrant.js";

/**
 * reuse an existing role, or create a new one.
 */
export const RoleAction = {
  Reuse: "reuse",
  Create: "create",
} as const;
/**
 * reuse an existing role, or create a new one.
 */
export type RoleAction = OpenEnum<typeof RoleAction>;

export type DirectoryRoleSetupProposedRole = {
  /**
   * Grants the existing role already has. Applying the proposal approves them for the source's members. Empty for a new role.
   */
  currentGrants: Array<RoleGrant>;
  /**
   * reuse an existing role, or create a new one.
   */
  roleAction: RoleAction;
  /**
   * The existing role. Set when role_action is reuse.
   */
  roleId?: string | undefined;
  /**
   * The existing role's name, or the name a new role would get.
   */
  roleName: string;
  /**
   * Principal URN of the existing role. Set when role_action is reuse.
   */
  roleUrn?: string | undefined;
};

/** @internal */
export const RoleAction$inboundSchema: z.ZodMiniType<RoleAction, unknown> =
  openEnums.inboundSchema(RoleAction);

/** @internal */
export const DirectoryRoleSetupProposedRole$inboundSchema: z.ZodMiniType<
  DirectoryRoleSetupProposedRole,
  unknown
> = z.pipe(
  z.object({
    current_grants: z.array(RoleGrant$inboundSchema),
    role_action: RoleAction$inboundSchema,
    role_id: z.optional(z.string()),
    role_name: z.string(),
    role_urn: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "current_grants": "currentGrants",
      "role_action": "roleAction",
      "role_id": "roleId",
      "role_name": "roleName",
      "role_urn": "roleUrn",
    });
  }),
);

export function directoryRoleSetupProposedRoleFromJSON(
  jsonString: string,
): SafeParseResult<DirectoryRoleSetupProposedRole, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DirectoryRoleSetupProposedRole$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DirectoryRoleSetupProposedRole' from JSON`,
  );
}
